import { Button, Card, Col, Input, List, Row, Tooltip, notification } from "antd";
import axios from "axios";
import { API_ENDPOINT } from "../api/endPoint";
import { useState, useCallback } from "react";
import debounce from "lodash.debounce";
import { MenuFoldOutlined, MenuUnfoldOutlined, SettingOutlined, ArrowLeftOutlined, UserOutlined, VideoCameraOutlined, PlusCircleOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import CustomerAddress from "./CustomerAddress";
import CustomerBasicDetails from "./CustomerBasicDetails";

export const CustomersScreen = () => {
  const [customers, setCustomers] = useState([]);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [addingCustomer, setAddingCustomer] = useState(null);
  const [editingAddress, setEditingAddress] = useState(null);
  const [isSavingCustomerAddress, setIsSavingCustomerAddress] = useState(false);
  const [isSavingCustomerBasicDetails, setIsSavingCustomerBasicDetails] = useState(false);
  const [currentEditingAddressType, setCurrentlyEditingAddressType] = useState(null);
  const [q, setSearchQuery] = useState(undefined);

  const [api, contextHolder] = notification.useNotification();

  const saveEditedAddress = async (addr, addressType) => {
    setIsSavingCustomerAddress(true);
    if (addr._id) {
      try {
        let response = await axios.put(API_ENDPOINT + `/users/customers/address/${addressType}`, {
          address: {
            id: addr._id,
            country: addr.country,
            name: addr.name,
            attention: addr.attention,
            email: addr.email,
            phone: addr.phone,
            addressLine1: addr.addressLine1,
            addressLine2: addr.addressLine2,
            addressLine3: addr.addressLine3,
            city: addr.city,
            zip: addr.zip,
            state: addr.state,
            GSTIN: addr.GSTIN,
          },
          customerId: addr.customerId,
        });
        console.log(response.data);
        if (response.data.success) {
          api.success({
            message: "Customer Management",
            description: "Successfully saved Customer Address.",
          });
        } else {
          api.error({
            message: "Customer Management",
            description: response.data.message,
          });
        }
        setIsSavingCustomerAddress(false);
        getAllCustomers(q);
        setEditingCustomer(undefined);
        setEditingAddress(undefined);
      } catch (err) {
        console.log(err);
        setIsSavingCustomerAddress(false);
      }
    } else {
      try {
        let response = await axios.post(API_ENDPOINT + `/users/customers/address/${addressType}`, {
          address: {
            country: addr.country,
            name: addr.name,
            attention: addr.attention,
            email: addr.email,
            phone: addr.phone,
            addressLine1: addr.addressLine1,
            addressLine2: addr.addressLine2,
            addressLine3: addr.addressLine3,
            city: addr.city,
            zip: addr.zip,
            state: addr.state,
            GSTIN: addr.GSTIN,
          },
          customerId: addr.customerId,
        });
        console.log(response.data);
        if (response.data.success) {
          api.success({
            message: "Customer Management",
            description: "Successfully saved Customer Address.",
          });
        } else {
          api.error({
            message: "Customer Management",
            description: response.data.message,
          });
        }
        setIsSavingCustomerAddress(false);
        getAllCustomers(q);
        setEditingCustomer(undefined);
        setEditingAddress(undefined);
      } catch (err) {
        console.log(err);
        setIsSavingCustomerAddress(false);
      }
    }
  };

  const saveEditedCustomer = async (addr) => {
    setIsSavingCustomerBasicDetails(true);
    if (addr.customerId) {
      try {
        let response = await axios.post(API_ENDPOINT + `/users/customers`, {
          name: addr.name,
          email: addr.email,
          phone: addr.phone,
          customerId: addr.customerId,
        });
        console.log(response.data);
        if (response.data.success) {
          api.success({
            message: "Customer Management",
            description: "Successfully saved Customer Details.",
          });
          getAllCustomers(q);
          setAddingCustomer(undefined);
          setEditingCustomer(undefined);
          setEditingAddress(undefined);
        } else {
          api.error({
            message: "Customer Management",
            description: response.data.message,
          });
        }
        setIsSavingCustomerBasicDetails(false);
      } catch (err) {
        console.log(err);
        setIsSavingCustomerBasicDetails(false);
      }
    } else {
      try {
        let response = await axios.post(API_ENDPOINT + `/users/customers`, {
          name: addr.name,
          email: addr.email,
          phone: addr.phone,
        });
        console.log(response.data);
        if (response.data.success) {
          api.success({
            message: "Customer Management",
            description: "Successfully saved Customer Details.",
          });
          getAllCustomers(q);
          setAddingCustomer(undefined);
          setEditingCustomer(undefined);
          setEditingAddress(undefined);
        } else {
          api.error({
            message: "Customer Management",
            description: response.data.message,
          });
        }
        setIsSavingCustomerBasicDetails(false);
      } catch (err) {
        console.log(err);
        setIsSavingCustomerBasicDetails(false);
      }
    }
  };

  const getAllCustomers = async (q) => {
    console.log("getAllCustomers called with phone:", q);
    try {
      setSearchQuery(q);
      let response = await axios.get(API_ENDPOINT + "/users/allCustomers?q=" + (q ? q : ""));
      if (response.data.users) {
        setCustomers(response.data.users);
        setAddingCustomer(undefined);
        setEditingCustomer(undefined);
        setEditingAddress(undefined);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const debouncedCustomerSearch = useCallback(
    debounce((event) => {
      getAllCustomers(event.target.value); // your API call
    }, 1000),
    []
  );

  const onCustomerEdit = (customer) => {
    console.log("onCustomerEdit", customer);
    setEditingCustomer(customer);
  };

  const onBillingAddressSelect = (address) => {
    console.log("onBillingAddressSelect", address);
    // You can implement further logic here, like opening an edit form
    setEditingAddress(address);
  };

  const onShippingAddressSelect = (address) => {
    console.log("onBillingAddressSelect", address);
    // You can implement further logic here, like opening an edit form
    setEditingAddress(address);
  };

  return (
    <Col span={24} style={{ padding: "20px" }}>
      {contextHolder}

      <Row justify={"end"} style={{ marginBottom: 20 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          style={{ backgroundColor: "#ae9572", color: "black" }}
          onClick={() => {
            setAddingCustomer({});
          }}
        >
          Add Customer
        </Button>
      </Row>

      {addingCustomer != null && (
        <div style={{ marginBottom: 20, marginTop: 20 }}>
          <CustomerBasicDetails
            address={addingCustomer}
            isSaving={isSavingCustomerBasicDetails}
            onCancel={() => {
              setAddingCustomer(undefined);
            }}
            onSave={(details) => {
              console.log("Customer details changed:", details);
              let finalDetails = { ...addingCustomer, ...details };
              setAddingCustomer(finalDetails);
              saveEditedCustomer(finalDetails);
            }}
          />
        </div>
      )}

      <Input placeholder="Enter Phone Number / Email ID / Customer ID" onChange={debouncedCustomerSearch} />
      {customers.length > 0 && (
        <List
          size="small"
          grid={{ column: 4 }}
          dataSource={customers}
          style={{ marginTop: 10 }}
          renderItem={(item) => (
            <List.Item>
              <Card title={item.name + " (ID: " + item.customerId + ")"}>
                <p> Email : {item.email}</p>
                <p> Phone : {item.phone}</p>
                <Button type="primary" icon={<EditOutlined />} style={{ backgroundColor: "#ae9572", color: "black", width: "100%" }} onClick={() => onCustomerEdit(item)}>
                  Edit Customer
                </Button>
              </Card>
            </List.Item>
          )}
        />
      )}

      {editingCustomer != null && (
        <CustomerBasicDetails
          address={editingCustomer}
          isSaving={isSavingCustomerBasicDetails}
          onCancel={() => {
            setEditingCustomer(undefined);
          }}
          onSave={(details) => {
            console.log("Customer details changed:", details);
            let finalDetails = { ...editingCustomer, ...details };
            setEditingCustomer(finalDetails);
            saveEditedCustomer(finalDetails);
          }}
        />
      )}

      {editingCustomer != null && (
        <Col span={24} style={{ marginTop: 20 }}>
          <Card title={`Editing Customer: ${editingCustomer.name} (ID: ${editingCustomer.customerId})`}>
            <Row gutter={16}>
              <Col span={12}>
                <Row justify="space-between" align="middle">
                  <b>Billing Addresses :</b>
                  <Tooltip title="Add Billing Address">
                    <Button
                      type="primary"
                      size={"large"}
                      icon={<PlusCircleOutlined />}
                      onClick={() => {
                        setCurrentlyEditingAddressType("billing");
                        onBillingAddressSelect({ country: "India", customerId: editingCustomer.customerId });
                      }}
                    />
                  </Tooltip>
                </Row>
                <List
                  size="small"
                  grid={{ column: 2 }}
                  dataSource={editingCustomer.billingAddresses}
                  style={{ marginTop: 10 }}
                  renderItem={(item) => (
                    <List.Item>
                      <Card title={item.name}>
                        <p>Attention : {item.attention}</p>
                        <p>Email : {item.email}</p>
                        <p>Phone : {item.phone}</p>
                        <p>
                          {item.addressLine1}
                          <br />
                          {item.addressLine2}
                          <br />
                          {item.addressLine3}
                          <br />
                          {item.city}, {item.state} - {item.zip}
                        </p>
                        <Button
                          type="primary"
                          shape="circle"
                          icon={<EditOutlined />}
                          style={{ backgroundColor: "#ae9572", color: "black" }}
                          onClick={() => {
                            setCurrentlyEditingAddressType("billing");
                            onBillingAddressSelect(item);
                          }}
                        ></Button>
                      </Card>
                    </List.Item>
                  )}
                />
              </Col>
              <Col span={12}>
                <Row justify="space-between" align="middle">
                  <b>Shipping Addresses :</b>
                  <Tooltip title="Add Shipping Address">
                    <Button
                      type="primary"
                      size={"large"}
                      icon={
                        <PlusCircleOutlined
                          onClick={() => {
                            setCurrentlyEditingAddressType("shipping");
                            onShippingAddressSelect({ country: "India", customerId: editingCustomer.customerId });
                          }}
                        />
                      }
                    />
                  </Tooltip>
                </Row>
                <List
                  size="small"
                  grid={{ column: 2 }}
                  dataSource={editingCustomer.shippingAddresses}
                  style={{ marginTop: 10 }}
                  renderItem={(item) => (
                    <List.Item>
                      <Card title={item.name}>
                        <p>Attention : {item.attention}</p>
                        <p>Email : {item.email}</p>
                        <p>Phone : {item.phone}</p>
                        <p>
                          {item.addressLine1}
                          <br />
                          {item.addressLine2}
                          <br />
                          {item.addressLine3}
                          <br />
                          {item.city}, {item.state} - {item.zip}
                        </p>
                        <Button
                          type="primary"
                          shape="circle"
                          icon={<EditOutlined />}
                          style={{ backgroundColor: "#ae9572", color: "black" }}
                          onClick={() => {
                            setCurrentlyEditingAddressType("shipping");
                            onShippingAddressSelect(item);
                          }}
                        ></Button>
                      </Card>
                    </List.Item>
                  )}
                />
              </Col>
            </Row>

            {editingAddress != null && (
              <CustomerAddress
                address={editingAddress}
                isSaving={isSavingCustomerAddress}
                onCancel={() => {
                  setEditingAddress(undefined);
                }}
                onSave={(addr) => {
                  console.log("Address changed:", addr);
                  let finalAddress = { ...editingAddress, ...addr };
                  setEditingAddress(finalAddress);
                  saveEditedAddress(finalAddress, currentEditingAddressType);
                }}
              />
            )}
          </Card>
        </Col>
      )}
    </Col>
  );
};
